module.exports = __webpack_public_path__ + "static/img/C (30).48b5795d.png";